import { useSelector } from 'react-redux';

import usePageTitle from '@/hooks/usePageTitle';
import { RootState } from '@/redux/store';
import useCreateOrder from '@/sections/create-order/use-create-order';

const DEFAULT_CENTER_BY_COUNTRY: Record<string, [number, number]> = {
  MEX: [-99.1269, 19.4978], // Ciudad de México
  PER: [-77.0428, -12.0464], // Lima
  CHL: [-70.6483, -33.4569], // Santiago
  COL: [-74.0721, 4.711], // Bogotá
};

export const useCreateOrderPage = () => {
  usePageTitle('Crear orden');
  const orderHook = useCreateOrder();
  const { profile } = useSelector((state: RootState) => state.parcel);

  const defaultCenter =
    DEFAULT_CENTER_BY_COUNTRY[profile.data?.country ?? ''] ?? DEFAULT_CENTER_BY_COUNTRY.MEX;

  const validPoint = orderHook.coordinatesPoint?.find((point) =>
    Boolean(
      point &&
      point.lat &&
      point.lng &&
      !isNaN(parseFloat(point.lat)) &&
      !isNaN(parseFloat(point.lng)),
    ),
  );

  const center: [number, number] = validPoint
    ? [parseFloat(validPoint.lng!), parseFloat(validPoint.lat!)]
    : defaultCenter;

  return {
    orderHook,
    center,
  };
};
